<template>
  <div id="gallery">
    <div class="row text-center">
      <div class="col-md-12 span-hover">
        <h1 class="title">{{$t('galleryTitle')}}</h1>
        <span class="cizgi"></span>
      </div>
    </div>
    <div class="row mt-5 mb-5">
      <carousel-3d
        :autoplay="true"
        :autoplayTimeout="5000"
        :display="13"
        :animationSpeed="1000"
        :border="0"
        :controls-visible="true"
      >
        <slide :index="i" v-for="(photo, i) in photo" :key="i">
          <img
            :src="require('@/assets/gallery/'+ photo )"
            :alt="photo"
            width="360"
            height="270"
          />
        </slide>
      </carousel-3d>
    </div>
  </div>
</template>
<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
export default {
  data() {
    return {
      photo: [
        "zsk (1).jpg",
        "zsk (2).jpg",
        "zsk (3).jpg",
        "zsk (4).jpg",
        "zsk (5).jpg",
        "zsk (6).jpg",
        "zsk (7).jpg",
        "zsk (8).jpg",
        "zsk (9).jpg",
        "zsk (10).jpg",
        "zsk (11).jpg",
        "zsk (12).jpg",
        
      ]
    };
  },
  methods: {},
  components: {
    Carousel3d,
    Slide
  }
};
</script>

<style scoped>
* {
  font-family: "Quicksand", sans-serif;
}
h1{
   font-family: 'Sansita Swashed', cursive;
   font-size:45px;
}
.carousel-3d-slide {
  -webkit-box-shadow: 0px 0px 62px 10px rgba(0, 0, 0, 0.45);
  -moz-box-shadow: 0px 0px 62px 10px rgba(0, 0, 0, 0.45);
  box-shadow: 0px 0px 30px 10px rgba(0, 0, 0, 0.45);
}
.carousel-3d-slide.current {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.cizgi {
  width: 100px;
  height: 5px;
  background: #333;
  display: block;
  border-radius: 0 0 4px 4px;
  margin: auto;
  transition: all 0.3s ease-in-out;
}
.span-hover:hover .cizgi {
  width: 200px;
  transition: all 0.3s ease-in-out;
}
.next, .prev{
  color:white !important ;
}
</style>
